import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

export interface IAddL1ServiceResponse {
  status: boolean;
  message: string;
  data: { service_id: string };
}

// export interface IAddL1ServiceProps {
//   service_name: string;
// }
export interface IServiceResponse {
  status: boolean;
  message: string;
}
export const useAddL1ServiceAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (serviceName: string, serviceTypeId: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: IServiceResponse = await axios
          .post(
            `${CONFIGURATION_APIS?.ADDL1SERVICE?.baseURL}?section=only_service` ?? "",
            { service_name: serviceName, service_type_id: serviceTypeId },
            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            },
          )
          .then((res: AxiosResponse<IAddL1ServiceResponse>) => {
            if (res.data.status === true) {
              toast.success("Service has been added.");
              return { status: true, message: res.data.data.service_id };
            } else {
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);

            return { status: false, message: null };
          });
        return response;
      } catch (e: any) {
        // toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute };
};
